export default __webpack_public_path__ + "static/media/logo.89049e08.png";